import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router";
import { Button, FoodsIcon } from "@foodpilot/foods";
import { useFoodpilotContext } from "src/context/FoodpilotContext.tsx";
import { CREATE, PRODUCT } from "src/context/FoodpilotContext.tsx";
import { URLHandler } from "src/services/URLHandler";

export const IntermediateProductPopover = () => {
    const { t } = useTranslation();
    const { canUser, selectedCompany } = useFoodpilotContext();
    const navigate = useNavigate();
    const location = useLocation();

    // Action directe pour créer un produit intermédiaire
    const handleCreateIntermediateProduct = () => {
        if (selectedCompany === null) return;
        const currentUrl = location.pathname + location.search;
        const createUrl = URLHandler.intermediateProduct.create(selectedCompany.id, 0);
        navigate(`${createUrl}?returnUrl=${encodeURIComponent(currentUrl)}`);
    };

    return (
        <>
            {canUser(CREATE, PRODUCT) && (
                <Button
                    variant="primary"
                    id="create-intermediate-product-button"
                    onClick={handleCreateIntermediateProduct}
                    startIcon={<FoodsIcon size={2} icon="plus" />}
                >
                    {t("intermediate_product.create", "Create an intermediate product")}
                </Button>
            )}
        </>
    );
};
